import { axios, Response } from '../index'

export interface Body {
  name: string
  parentFolderId?: string
}

const shareFolder = (
  personaId: string,
  folderId: string,
  permissionName: string
): Response<null> => {
  return axios.post(
    `/v1/folders/${folderId}/personas/${personaId}/permissions/${permissionName}`
  )
}

export default shareFolder
